import React from "react";
import { Box, CssBaseline, Stack } from "@mui/material";
import page_top_array from "../Arrays/page-top-array";
import PageTopElements from "./PageTopElements";

function createTopElements(elements) {
    return <PageTopElements alt={elements.alt} 
    img={elements.imgURL}
    text={elements.text}
    />;
}

function PageTop() {
    return ( 
        <>
        <CssBaseline />
        <Box sx={{ marginTop: "0px" }}>

            <Stack sx={{ height: "450px" }}>
                <Stack component="img" sx={{ objectFit: "cover", height: "550px"}}
                    alt="Pessoas se exercitando."
                    src="images/imagem-topo.jpg" />
            </Stack>

            <Stack  direction={{xs: 'column', sm:'row'}} justifyContent="center" alignItems="center" spacing={2}>

                {page_top_array.map(createTopElements)}

            </Stack>
        </Box>
        </>    
    );
};
export default PageTop;

